import { useContext } from 'react';
import CacheContext from '../contexts/CacheContext';

const useCacheContext = () => useContext(CacheContext);

export default useCacheContext;
